const MONTHS = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

const SENT_AT_PATTERN = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;

/**
 * sentAt llega como hora de México, sin zona.
 * Se toman año, mes y día del texto para que el huso del
 * dispositivo no mueva el día. No se usa new Date(string).
 */
export function parseSentAt(sentAt) {
  if (typeof sentAt !== 'string' || !sentAt) {
    return { dateKey: '', label: '' };
  }
  const match = SENT_AT_PATTERN.exec(sentAt);
  if (!match) {
    return { dateKey: '', label: sentAt };
  }
  const year = match[1];
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return { dateKey: '', label: sentAt };
  }
  return {
    dateKey: `${year}-${match[2]}-${match[3]}`,
    label: `${day} de ${MONTHS[month - 1]} de ${year}`,
  };
}

export function mapNotificationListItem(item = {}) {
  const sent = parseSentAt(item.sentAt);
  return {
    id: item.id == null ? '' : String(item.id),
    title: item.title || '',
    message: item.message || '',
    category: item.category || '',
    sentAt: item.sentAt || '',
    dateKey: sent.dateKey,
    dateLabel: sent.label,
  };
}

export function mapNotificationPage(page = {}) {
  const content = Array.isArray(page.content) ? page.content : [];
  return {
    items: content.map(mapNotificationListItem),
    last: page.last === true,
    number: Number.isInteger(page.number) ? page.number : 0,
    empty: page.empty === true || content.length === 0,
  };
}

export function mapNotificationDetail(item = {}) {
  return {
    ...mapNotificationListItem(item),
    content: typeof item.content === 'string' ? item.content : '',
    data: item.data === undefined ? null : item.data,
  };
}

export function groupNotificationsByDate(items = []) {
  const groups = [];
  items.forEach((item) => {
    const key = item.dateKey || item.sentAt || '';
    const current = groups[groups.length - 1];
    if (current && current.key === key) {
      current.items.push(item);
      return;
    }
    groups.push({
      key,
      label: item.dateLabel || item.sentAt || '',
      items: [item],
    });
  });
  return groups;
}

export function appendUnique(current = [], incoming = []) {
  const seen = new Set(current.map((item) => item.id).filter(Boolean));
  const next = current.slice();
  incoming.forEach((item) => {
    if (item.id && seen.has(item.id)) return;
    if (item.id) seen.add(item.id);
    next.push(item);
  });
  return next;
}
